import { ChatMessage } from '../value_objects/chat-message.value-object';
import { ChatConnectionStatus } from '../value_objects/connection-status.value-object';

/**
 * Chat Session Entity
 * Represents an active chat conversation session
 */
export class ChatSession {
    private constructor(
        private readonly _sessionId: string,
        private _messages: ChatMessage[],
        private _connectionStatus: ChatConnectionStatus,
        private readonly _userId: string,
        private readonly _createdAt: Date
    ) { }

    static create(props: {
        sessionId: string;
        userId: string;
        messages?: ChatMessage[];
        connectionStatus?: ChatConnectionStatus;
        createdAt?: Date;
    }): ChatSession {
        return new ChatSession(
            props.sessionId,
            props.messages || [],
            props.connectionStatus || ChatConnectionStatus.disconnected(),
            props.userId,
            props.createdAt || new Date()
        );
    }

    get sessionId(): string {
        return this._sessionId;
    }

    get messages(): ChatMessage[] {
        return [...this._messages];
    }

    get connectionStatus(): ChatConnectionStatus {
        return this._connectionStatus;
    }

    get userId(): string {
        return this._userId;
    }

    get createdAt(): Date {
        return this._createdAt;
    }

    get lastMessage(): ChatMessage | null {
        return this._messages.length > 0 ? this._messages[this._messages.length - 1] : null;
    }

    get messageCount(): number {
        return this._messages.length;
    }

    addMessage(message: ChatMessage): void {
        this._messages.push(message);
    }

    updateConnectionStatus(status: ChatConnectionStatus): void {
        this._connectionStatus = status;
    }

    clearMessages(): void {
        this._messages = [];
    }
}
